import "./App.css";
import {
  Header,
  HeroBanner,
  HeaderWrapper,
  AppWrapper,
  SectionWrapper,
  SectionTitle,
  SportsContainer,
  LogoWrapper,
} from "./Components.styles";
import { DropdownWithLabel } from "./Components";
import Logo from "./logowf.png";

import competitions from "./lists/graphs.json";
// import sportAllOptions from "./lists/sports.json";
// import countryAllOptions from "./lists/countries.json";
// import datesAllOptions from "./lists/dates.json";
import { StringParam, useQueryParam } from "use-query-params";
import { SportTile } from "./components/SportTile";
import { useEffect, useState } from "react";
import GraphModal from "./components/GraphModal";

function App() {
  const [country, setCountry] = useQueryParam("country", StringParam);
  const [sport, setSport] = useQueryParam("sport", StringParam);
  const [date, setDate] = useQueryParam("date", StringParam);
  const [selectedTile, setSelectedTile] = useState({});
  const [filteredCompetitions, setFilteredCompetitions] = useState([]);

  const [countryOptions, setCountryOptions] = useState([]);
  const [sportOptions, setSportOptions] = useState([]);
  const [datesOptions, setDateOptions] = useState([]);

  useEffect(() => {
    // if(Object.keys(selectedTile).length ===0) return;
    setFilteredCompetitions(
      competitions
        .filter(
          (competition) =>
            (!date ? true : date === competition.date) &&
            (!sport ? true : sport === competition.sport) &&
            (!country ? true : competition.countries.indexOf(country) !== -1)
        )
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    );
  }, [country, sport, date]);

  useEffect(() => {
    // if(Object.keys(selectedTile).length ===0) return;
    setCountryOptions(
      Object.keys(
        filteredCompetitions.reduce((acc, curr) => {
          return {
            ...acc,
            ...curr.countries.reduce((a, c) => ({ ...a, [c]: "" }), {}),
          };
        }, {})
      ).map((o) => ({ label: o, value: o }))
    );
    setSportOptions(
      Object.keys(
        filteredCompetitions.reduce(
          (acc, curr) => ({ ...acc, [curr.sport]: "" }),
          {}
        )
      ).map((o) => ({ label: o, value: o }))
    );
    setDateOptions(
      Object.keys(
        filteredCompetitions.reduce(
          (acc, curr) => ({ ...acc, [curr.date]: "" }),
          {}
        )
      ).map((o) => ({ label: o, value: o }))
    );
    // setFilteredCompetitions(competitions.filter((competition) => (!date ? true : date === competition.date) && (!sport ? true : sport === competition.sport) && (!country ? true : competition.countries.indexOf(country)!== -1)))
  }, [filteredCompetitions]);

  return (
    <div className="App">
      {selectedTile && Object.keys(selectedTile).length && (
        <GraphModal {...selectedTile} onClickOut={() => setSelectedTile({})} />
      )}
      <AppWrapper>
        <HeaderWrapper>
          <Header>
          <a href={"https://plotparade.com/"}><LogoWrapper src={Logo} /></a>
          <div className="MenuRight"><a href={"https://www.etsy.com/shop/PlotParade"} target={"_blank"} >{"Shop"}</a>
           <a href={"https://krisztinaszucs.com/"}  target={"_blank"} >{"Krisztina Szucs"}</a> 
           <a href={"https://twitter.com/szucsi"} target={"_blank"}  >{"@szucsi"}</a>
           </div>
          </Header>
          <HeroBanner>
            <DropdownWithLabel
              key="event"
              label={"Event"}
              value={sport}
              options={sportOptions}
              onChange={setSport}
            />
            <DropdownWithLabel
              key="country"
              label={"Country"}
              value={country}
              options={countryOptions}
              onChange={setCountry}
            />
            <DropdownWithLabel
              key="date"
              label={"Date"}
              value={date}
              options={datesOptions}
              onChange={setDate}
            />
          </HeroBanner>
        </HeaderWrapper>
        <SectionWrapper>
          <SectionTitle>{"Results"}</SectionTitle>
          <SportsContainer>
            {filteredCompetitions.map((competition) => {
              return (
                <SportTile
                  key={competition.id}
                  onTileSelect={setSelectedTile}
                  {...competition}
                  // sport={competition.sport}
                  // category={competition.category}
                  // tier={competition.title}
                  // date={competition.date}
                  // result={competition.result}
                  // medals={[
                  //   { class: "gold", country: "HUN" },
                  //   { class: "silver", country: "GRE" },
                  // ]}
                  // thumbnail={competition.thumbnail}
                />
              ); //(JSON.stringify(sport))
            })}
          </SportsContainer>
          {/* <SportTile
          thumbnail="https://source.unsplash.com/512x512/?nature,water"
          sport="Water Polo"
          category="Men"
          tier="Semifinal"
          date="2016 August 16"
          result={"HUN-GRE\nTest"}
          medals={[
            {class:"gold", country:"HUN"},
            {class:"silver", country:"GRE"}
          ]}
        />
        <SportTile
          // thumbnail="https://source.unsplash.com/512x512/?nature,water"
          sport="Water Polo"
          category="Men"
          tier="Semifinal"
          date="2016 August 16"
          result={"HUN-GRE\nTest"}
          medals={[
            {class:"gold", country:"HUN"},
            {class:"silver", country:"GRE"}
          ]}
        /> */}
        </SectionWrapper>
      </AppWrapper>
    </div>
  );
}

export default App;
